import $ from 'jquery';
import { showSidebarTab } from '~src/sidebarLegacy';
import { getState, unsetState } from '~src/state';
import { injectMagicEraserCanvasHtml } from '~core/magicEraser';
import { toggleSaveNavMenu } from '~core/navbar';
import { getGlobalControlsManager } from '~core/customControls';

export const stopMagicEraser = async (tabTargetId) => {
  console.log('stopMagicEraser', tabTargetId);
  const selection = getState('magicEraserSelection');
  if (selection) {
    window.canvas.setActiveObject(selection);
  }
  unsetState('isMagicEraserActive');
  unsetState('magicEraserTargetImageUrl');
  unsetState('magicEraserTarget');
  unsetState('magicEraserResultImageUrl');
  unsetState('magicEraserMaskUrl');
  unsetState('stopKeyboardListener');
  unsetState('magicEraserSelection');
  if (!tabTargetId) {
    showSidebarTab('edit-images-ai');
  }
  toggleSaveNavMenu();
  const initialCanvasZoom = getState('initialCanvasZoom');
  $('#canvas-zoom').css('transform', `scale(${initialCanvasZoom})`);
  $('#editor-zoom-controls').show();
  $('#editor-menu-run-magic-eraser').attr('disabled', true);
  $('#editor-menu-run-magic-eraser').attr('disabled', true);
  $('#magic-eraser-container').hide();
  $('#drawing-magic-eraser-canvas').fadeOut(() => {
    $('#main-canvas-container').fadeIn();
    $('#canvas').removeClass('locked').show();
    const cursorCanvas = getState('cursorCanvas');
    const mouseCursor = getState('mouseCursorMagicEraser');
    mouseCursor.set('visible', false);
    cursorCanvas.renderAll();
    try {
      const cm = getGlobalControlsManager();
      const obj = getState('magicEraserSelection');
      if (cm && obj) cm.showControl(obj);
    } catch (e) {
      console.error('Failed showing control after stopping Magic Eraser', e);
    }
  });
  window.magicEraserDrawingCanvas.clear();
  window.magicEraserManipulationCanvas.clear();
  window.magicEraserDrawingCanvas.dispose();
  window.magicEraserManipulationCanvas.dispose();
  window.magicEraserDrawingCanvas = null;
  window.magicEraserManipulationCanvas = null;
  injectMagicEraserCanvasHtml();
};
